import React from "react";
import publications from "../data/publications";
import Grouped from "../Components/Grouped";

const Authors = ({ authors }) => (
  <span className="authors">
    {authors.map((author, i) => (
      <span className="author-entry" key={i}>
        {author + (i === authors.length - 1 ? ". " : ", ")}
      </span>
    ))}
  </span>
);
const Publication = ({
  authors,
  title,
  venue,
  year,
  link,
  lineBreak = false,
}) => (
  <span className="publication">
    <span className="title">
      <a className="link" href={link}>
        {title}
      </a>
    </span>
    <br />
    <Authors authors={authors} />
    <span>{venue}. </span>
    <span>{year}. </span>
    <br />
    <br />
  </span>
);

const Publications = ({ showTitle = false, grouped = true }) => {
  return (
    <div className="publications page">
      {showTitle ? <h2 className="title">Publications</h2> : ""}
      {showTitle ? <br /> : ""}
      {grouped ? (
        <Grouped
          data={publications.slice().reverse()}
          by="year"
          Component={Publication}
        />
      ) : (
        publications.map((publication, i) => (
          <Publication {...publication} lineBreak={true} />
        ))
      )}
    </div>
  );
};

export default Publications;
